<template>
    <div class="newExamTopicDialog">

        <el-dialog fullscreen :visible.sync="dialogVisible" :close-on-click-modal="false" :title=myTitle @close="cancel">
            <h1 style="font-size: 25px;margin-bottom: 10px;">
                <!-- 试卷答案与分值配置 -->
                <!-- 本答题卡共有{{ topicNum }}道题: 客观题 {{ kgNum }} 道，共{{ kgScore }}分、 主观题{{ zgNum }} 道，共{{ zgScore}}分， 总分值 <span style="color: red; font-size: 25px;"> {{ totalScore }} </span>分  -->
            </h1>

            <div class="card-stats">
                <el-card>
                    <h1> 题目总数</h1>
                    <h2> {{ topicNum }} 题</h2>
                </el-card>
                <el-card>
                    <h1> 客观题</h1>
                    <h2> {{ kgNum }} 题 ({{ kgScore}}分)</h2>
                </el-card>
                <el-card>
                    <h1> 主观题</h1>
                    <h2> {{ zgNum }}题 ({{ zgScore}}分)</h2>
                </el-card>
                <el-card>
                    <h1> 总分值</h1>
                    <h2> {{ totalScore }} 分</h2>
                </el-card>
            </div>
        <el-row>
            <el-col :span="19">
                <el-card  class="fixed-blue-card">

               
                <!-- flx 布局 -->
                <div class="container">
                    <!--垂直布局 -->
                    <template  v-for="info in zgInfo" >
                        <!-- 客观题 -->
                        <div v-if="info.type == 'kg'" class="card-vertical">
                            
                            <div  v-for="(item,index) in info.list" :key= index  class="card-horizontal" >
                                <!-- 题号 -->
                                <div style="width: 35px"> <span>{{ item.numNum }}</span></div>

                                    <!-- 单选题 -->
                                    <div class="letter-container" v-if="item.topic_type =='SingleChoice'">
                                        <span
                                        v-for="letter in getCheckList(item.option_count)"
                                        :key="letter"
                                        class="letter-item"
                                        :class="{ active: item.answer == letter }"
                                        @click="singleChoiceCheck(item,letter)"
                                        >
                                        [{{ letter }}]
                                        </span>
                                    </div>

                                    <!-- 多选题 -->
                                    <div class="letter-container" v-if="item.topic_type =='MultiChoice'">
                                        <span
                                        v-for="letter in getCheckList(item.option_count)"
                                        :key="letter"
                                        class="letter-item multi_choice"
                                        :class="{ active: item.answer.includes(letter) }"
                                        @click="multiChoiceCheck(item,letter)"
                                        >
                                        [{{ letter }}]
                                        </span>
                                    </div>

                                    <!-- 判断题 -->
                                    <div class="letter-container" v-if="item.topic_type =='Judge'">
                                            <span
                                            v-for="letter in ['T','F']"
                                            :key="letter"
                                            class="letter-item"
                                            :class="{ active: item.answer == letter }"
                                            @click="singleChoiceCheck(item,letter)"
                                            >
                                            [{{ letter }}]
                                            </span>
                                    </div>
                            </div> 
                        </div>

                        <!-- 主观题 -->
                        <div v-else-if="info.type == 'zg'"  class="card-vertical">                     
                            <!-- <div  v-for="(item,index) in info.list" :key= index  class="card-horizontal">
                                <span> {{ formatTitle( item.topic_type) }}： </span>
                                <div> <span> {{item.numNum }}</span> 题</div>
                            </div> -->

                            <div  class="card-horizontal">
                                <span style="font-size:18px">
                                    {{ zgTopicGroup(info) }}
                                </span>
                                <!-- {{info.list[0].isExist}} -->
                            </div>
                        </div>

                        <!-- 标题 批量设置分数  -->
                        <div v-else-if="info.type == 'input'" style="width: 100%" >
                            <!-- 标题处 -->
                            <div style="display: flex; align-items: left; ">
                                <h1 style="font-size: 20px;">题目：</h1>

                                <div v-html="info.name"></div>
                            </div>
                            <div class="wrapper">

                            
                            <!-- <el-row> -->
                                <!-- <el-col :span="12"> -->
                                    <div style="display: flex; align-items: center; ">
                                        <!-- <span> 设置分数 </span> -->
                                        <!-- {{ info }} -->
                                        <span v-if = "info.topic_type == 'SingleChoice' || info.topic_type == 'MultiChoice' ||info.topic_type == 'Judge' || info.topic_type == 'FillBlank'" style="font-size:18px"> 批量设置分值:</span>
                                        <span v-else style="font-size:18px"> 分值:</span>
                                        <el-input style="width: 120px; margin-left: 20px;" v-model="info.batchScore" class="fixed-blue-input" @focus="batchScoreByGroupCheck(info)" @input="batchScoreByGroup(info)"  placeholder="请输入分值" oninput="value=value.match(/^\d*\.?\d{0,3}$/)||''"></el-input>
                                    </div>
                                <!-- </el-col> -->
                                
                                <!-- 客观题才可批量设置答案  -->
                                <!-- <el-col :span="12" > -->
                                    <div style="display: flex; align-items: center;  " v-if="info.topic_type == 'Object' ">
                                        <span style="font-size:18px;width:80px;margin-left: 10px">答案:</span>
                                        <el-tooltip class="item" effect="dark" content="格式：A,B,AB,或T,T,F,F，每题英文逗号隔开" placement="top">
                                            <el-input style="min-width: 500px" v-model="info.batchAnswer" @focus="batchAnswerByGroupCheck(info)" @input="batchAnswerByGroup(info)" class="fixed-blue-input" placeholder="每题英文逗号隔开，格式：A,B,AB,或T,T,F,F，" ></el-input>
                                        </el-tooltip>
                                        
                                    </div>
                                <!-- </el-col> -->



                                <!-- <el-col :span="6"></el-col> -->
                            <!-- </el-row> -->
                            </div>

                        </div>

                        <!-- 横线切割 -->
                        <div v-else class="break-line"> </div> 

                    </template >
                </div>

            </el-card>

            </el-col>



            <el-col :span="5"  class="fixed-sidebar" >
                <div>
                    <el-collapse v-model="activeNames" @change="handleChange" >
                        <!-- 循环生成折叠项 -->
                        <el-collapse-item 
                            v-for="(item, index) in scoreList" 
                            :key="item.groupId"
                            :title="formatTitle(item.topic_type)"
                            :name="item.groupId" 
                            
                        >
                        <template slot="title">
                            <div class="title-wrapper">
                                <span class="collapse-title" >{{formatTitle(item.topic_type)}}({{ item.totalNum }}题)</span>
                              
                                <span class="tip-num" v-if="isAnswerEmpty && isAnswerEmptyList[index].emptyCount  > 0" >答案:缺 {{ isAnswerEmptyList[index].emptyCount }} 题 </span>
                                <span class="tip-num" v-if="isScoreEmpty && isScoreEmptyList[index].emptyCount  > 0">分值:缺 {{ isScoreEmptyList[index].emptyCount }} 题 </span>
                            </div>
                        </template>
                        <el-button type="primary" size="mini" @click="changeTopicType(1,item)" v-if="item.topic_type == 'MultiChoice'">批量转单选题</el-button>
                        <el-button type="primary" size="mini" @click="changeTopicType(2,item)" v-if="item.topic_type == 'SingleChoice'"> 批量转多选题</el-button>
                        
                        <!-- 循环题号和分数(侧边栏) -->
                         <newExamTopicTable :ref="'newExamTopicTable-' + item.groupId"  :data="item.list" :type="item.topic_type" :groupId="item.groupId" @updateScoreList="updateScoreList" @changeTopicType="changeTopicTypeOne" @getSpecialData="getSpecialData" @setScoreRules="setScoreRules"></newExamTopicTable>

                        </el-collapse-item>
                    </el-collapse>
                </div>
            </el-col>

        </el-row>


            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" :loading="loading"  @click="submitCheck">保 存</el-button>
            </div>



        </el-dialog>


    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import * as simpleApi from "request/simple";
import XEUtils from 'xe-utils'
import * as mUtils from '@/utils/mUtils'
import topicSpecialDialog from "./topicSpecialDialog";
import answerHistory from "./answerHistory";
import newExamTopicTable from "./newExamTopicTable";
import { select } from "underscore";

    export default {
        name: 'newExamTopicLayoutDialog',
        data(){
            return {
                
                myTitle: '答案与分值设置', 
                dialogVisible:false, 
                loading: false,
                // 页面排版的json
                zgInfo: null,
                // 对应主客观题的索引位置
                zgInfoIndex: {},
                list: [],
                letters: [], // 字母列表 A-Z
                selectedLetters: [], // 已选中的字母
                // 批量设置分数列表/特殊规则
                scoreList: [],
                activeNames:[],
                // 总表数据
                totalTopicList:[],
                // 总表数据 - 更新
                totalTopicListById:[],
                // 总题数
                topicNum: 0,
                // 客观题数
                kgNum:0,
                // 主观题数
                zgNum:0,
                // 答题卡题目集合
                titleList:[],
                // 判断该考试是否保存过答案(是否新增)
                isInsert: true,
                // 答题卡信息
                scantronInfo: null,
                // isCheckEmpty: false,
                // isCheckEmptyList:[],

                isAnswerEmpty: false,
                isAnswerEmptyList:[],
                isScoreEmpty: false,
                isScoreEmptyList:[],

            }
        },
        components:{
            newExamTopicTable
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            }),
            totalScore() {
                let sum = 0
                this.scoreList.forEach(item => {
                    let total = item.list.filter(item => "rowId" in item).reduce((sum, item) => {
                       return sum + Math.round((item.score * 1 || 0) * 1000)
                    }, 0)
                    sum = sum + total
                })
                return sum / 1000
            },
            kgScore() {
                let sum = 0
                let kgList = this.scoreList.filter(item=> item.topic_type == "SingleChoice"  || item.topic_type == "MultiChoice" || item.topic_type == "Judge")
                kgList.forEach(item => {
                    let total = item.list.filter(item => "rowId" in item).reduce((sum, item) => {
                       return sum + Math.round((item.score * 1 || 0) * 1000)
                    }, 0)
                    sum += total
                })
                return sum / 1000
            },
            zgScore() {
                let sum = 0
                let kgList = this.scoreList.filter(item=> item.topic_type != "SingleChoice"  && item.topic_type != "MultiChoice" && item.topic_type != "Judge")
                kgList.forEach(item => {
                    let total = item.list.filter(item => "rowId" in item).reduce((sum, item) => {
                       return sum + Math.round((item.score * 1 || 0) * 1000)
                    }, 0)
                    sum = sum + total
                })
                return sum / 1000
            },
 

        },
        
      	mounted() {

	    },
        props: {
            examId: {
                type: Object
            }
        },
        watch: {
            
        },
        created() {
            // 生成 A-Z 字母
            for (let i = 65; i <= 90; i++) {
                this.letters.push(String.fromCharCode(i));
            }
        },
        methods: {
            showDialog(examId){
                this.examId = examId
                this.dialogVisible = true;
                // 获取试题
                this.getExam()
                // 获取答题卡
                this.getScantron()
                // 延时处理数据
                setTimeout(() => {
                    // 根据答题卡获取到答题卡格局和答题卡题目
                    this.getInfo()
                    this.changeTopic()
                }, 1000)


            },
            hideDialog(){
                this.dialogVisible = false;
            },
            cancel(){
                // 全部清空
                this.zgInfo = null
                this.zgInfoIndex= {}
                this.list = []
                this.selectedLetters = []
                this.scoreList = []
                this.totalTopicList = []
                this.totalTopicListById = []
                this.topicNum = 0
                this.kgNum = 0
                this.zgNum = 0
                this.titleList = []
                this.isInsert = true
                this.scantronInfo = null
                this.isAnswerEmpty = false
                this.isAnswerEmptyList =[]
                this.isScoreEmpty = false
                this.isScoreEmptyList= []

                this.dialogVisible = false;
                this.$emit('cancel');
            },
            // 转换题型名称
            formatTitle(topicType){
                let map = {
                    'SingleChoice': '单选题',
                    'MultiChoice': '多选题',
                    'Judge': '判断题',
                    'FillBlank': '填空题',
                    'AnswerQuestion': '解答题',
                    'EnglishComposition': '英语作文',
                    'Composition': '语文作文',
                }
                return map[topicType] || topicType
            },
            // 获取到对应考试的答题卡信息 提取出对应顺序的题目信息
            getTopicList(data){
                let topicCollections =JSON.parse(JSON.stringify(data))
                // 仅过滤被<p> 标签包裹的题目
                // let regex = /<p[^>]*>(.*?)<\/p>/g;
                // let matches = [...topicCollections.matchAll(regex)];
                // let title = matches.map(m => mUtils.cleanHtmlToText(m[1]));


                let list = JSON.parse(topicCollections)
                let topicTypeDescs = list.topicTypeDescs
                let title = []
                topicTypeDescs.forEach(element => {
                    // 判断下是否是简单的<p></p>这种无标题的 替换成无
                    let str = element.title == '<p></p>' ? '无' :element.title
                    title.push(str)
                });

                // 就按顺序把每道题的题目塞入到批量设置处
                this.titleList = title

            },
            // 生成[A~Z]
            getChoose(t, c){
                let i = c-1;
                if(t == 'SingleChoice' || t == 'MultiChoice'){
                    if(i==0) return "A";
                    if(i==1) return "B";
                    if(i==2) return "C";
                    if(i==3) return "D";
                    if(i==4) return "E";
                    if(i==5) return "F";
                    if(i==6) return "G";
                    if(i==7) return "H";
                    if(i==8) return "I";
                    if(i==9) return "J";
                    if(i==10) return "K";
                    if(i==11) return "L";
                    if(i==12) return "M";
                    if(i==13) return "N";
                    if(i==14) return "O";
                    if(i==15) return "P";
                    if(i==16) return "Q";
                }
                if(t == 'Judge') {
                    if (i == 0) return "T";
                    if (i == 1) return "F";
                }
            },
            turnChooses(cou){
                let myList = [];
                for (let i=0; i<cou; i++){
                    let c = '';
                    if(i==0) c = "A";
                    if(i==1) c = "B";
                    if(i==2) c = "C";
                    if(i==3) c = "D";
                    if(i==4) c = "E";
                    if(i==5) c = "F";
                    if(i==6) c = "G";
                    if(i==7) c = "H";
                    if(i==8) c = "I";
                    if(i==9) c = "J";
                    if(i==10) c = "K";
                    if(i==11) c = "L";
                    if(i==12) c = "M";
                    if(i==13) c = "N";
                    if(i==14) c = "O";
                    if(i==15) c = "P";
                    if(i==16) c = "Q";
                    myList.push(c);
                }
                return myList;
            },
            // 生成[A~Z]
            getCheckList(count){
                let list = []
                // 从A 开始计数
                let num = 65 + count
                // 生成 A-Z 字母
                for (let i = 65; i < num; i++) {
                    list.push(String.fromCharCode(i));
                }
                return list
            },
            // 读取对应考试是否绑定答题卡 是否已设置答案
            getExam(){
                let search = { examId: this.examId ,orderBy: 'topic_index'};
                let param = { controllerName: 'akExamTopic', methodName: '/listAll', param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    if(data.length > 0) {
                        // 更新操作
                        this.isInsert = false
                        this.totalTopicListById =  data
                    }
                })

            },
            getScantron(){
                let search = { examId: this.examId };
                let param = { controllerName: 'exam/scantron', methodName: '/getScantronByExamId', param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    this.scantronInfo = data
                    
                })
            },
            // 根据答题卡获取到答题卡格局和答题卡题目
            getInfo(){
                debugger
                let scantronInfo = this.scantronInfo
                // 答题卡位置信息
                let info = scantronInfo.location
                let topicCollections = scantronInfo.topicCollections

                // let info = '{"noAnswerMark":{"position":{"top":12,"left":99,"width":12,"height":12}},"pageSheets":[{"locatePoint":[{"top":12,"left":6,"width":5,"height":5,"index":1},{"top":12,"left":198.9999,"width":5,"height":5,"index":2},{"top":279.9999,"left":198.9999,"width":5,"height":5,"index":3},{"top":279.9999,"left":6,"width":5,"height":5,"index":4},{"top":247.5,"left":6,"width":5,"height":5,"index":5},{"top":197.9999,"left":6,"width":5,"height":5,"index":6},{"top":148.4999,"left":6,"width":5,"height":5,"index":7},{"top":98.9999,"left":6,"width":5,"height":5,"index":8},{"top":49.4999,"left":6,"width":5,"height":5,"index":9}],"sections":[{"type":"Object","contents":{"position":{"top":119.312,"left":15,"width":180,"height":30},"branch":[{"selectOptions":[],"chooseCount":4,"subAreaTopicType":"SingleChoice","position":{"top":0,"left":0,"width":34.9999,"height":30},"colOffset":6.75,"rowOffset":5,"ixList":[1,2,3,4,5],"numList":[1,2,3,4,5],"orientation":0,"firstOption":{"top":3.5291,"left":10.0098,"width":4,"height":3},"chooses":["A","B","C","D"]},{"selectOptions":[],"chooseCount":4,"subAreaTopicType":"SingleChoice","position":{"top":0,"left":34.9999,"width":34.9999,"height":30},"colOffset":6.75,"rowOffset":5,"ixList":[6,7,8,9,10],"numList":[6,7,8,9,10],"orientation":0,"firstOption":{"top":3.5291,"left":10.0098,"width":4,"height":3},"chooses":["A","B","C","D"]}]}},{"type":"FillBlank","contents":{"position":{"top":158.6241,"left":15,"width":180,"height":31.7459},"branch":[{"selectOptions":[],"numList":[1,2,3,4,5],"ixList":[11,12,13,14,15]}]}},{"type":"Object","contents":{"position":{"top":199.6822,"left":15,"width":180,"height":60},"branch":[{"selectOptions":[],"chooseCount":15,"subAreaTopicType":"MultiChoice","position":{"top":0,"left":0,"width":109.2499,"height":30},"colOffset":6.75,"rowOffset":5,"ixList":[16,17,18,19,20],"numList":[1,2,3,4,5],"orientation":0,"firstOption":{"top":3.5291,"left":10.0098,"width":4,"height":3},"chooses":["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O"]},{"selectOptions":[],"chooseCount":15,"subAreaTopicType":"MultiChoice","position":{"top":30,"left":0,"width":109.2499,"height":30},"colOffset":6.75,"rowOffset":5,"ixList":[21,22,23,24,25],"numList":[6,7,8,9,10],"orientation":0,"firstOption":{"top":3.5291,"left":10.0098,"width":4,"height":3},"chooses":["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O"]}]}}],"pageNumMarks":[{"children":[],"position":{"top":278,"left":33,"width":30,"height":10},"pageIndex":0,"blockCount":2,"firstOption":{"top":3,"left":5,"width":8,"height":4},"colOffset":11,"elementType":"PAGENUMICON","parent":null,"pTop":0}],"pageIndex":0,"qrCode":{"top":12,"left":164.5766,"width":15,"height":15},"absentMark":{"enabled":true,"position":{"top":104.2499,"left":54,"width":5,"height":2.5}},"cheatMark":{"position":{"top":101.4999,"left":70.1,"width":5,"height":2.5}},"ticketNum":{"enabled":true,"count":9,"position":{"top":56.9947,"left":106.2645,"width":63,"height":51.6666},"examNumberMode":0,"firstOption":{"top":0.9,"left":1.1,"width":4.7999,"height":3.2},"rowOffset":5.1666,"colOffset":7}},{"locatePoint":[{"top":12,"left":6,"width":5,"height":5,"index":1},{"top":12,"left":198.9999,"width":5,"height":5,"index":2},{"top":279.9999,"left":198.9999,"width":5,"height":5,"index":3},{"top":279.9999,"left":6,"width":5,"height":5,"index":4},{"top":247.5,"left":6,"width":5,"height":5,"index":5},{"top":197.9999,"left":6,"width":5,"height":5,"index":6},{"top":148.4999,"left":6,"width":5,"height":5,"index":7},{"top":98.9999,"left":6,"width":5,"height":5,"index":8},{"top":49.4999,"left":6,"width":5,"height":5,"index":9}],"sections":[{"type":"Object","contents":{"position":{"top":39,"left":15,"width":180,"height":60},"branch":[{"selectOptions":[],"chooseCount":15,"subAreaTopicType":"MultiChoice","position":{"top":0,"left":0,"width":109.2499,"height":30},"colOffset":6.75,"rowOffset":5,"ixList":[26,27,28,29,30],"numList":[11,12,13,14,15],"firstOption":{"top":3.5291,"left":10.0098,"width":4,"height":3},"chooses":["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O"]},{"selectOptions":[],"chooseCount":15,"subAreaTopicType":"MultiChoice","position":{"top":30,"left":0,"width":109.2499,"height":30},"colOffset":6.75,"rowOffset":5,"ixList":[31,32,33,34,35],"numList":[16,17,18,19,20],"firstOption":{"top":3.5291,"left":10.0098,"width":4,"height":3},"chooses":["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O"]}]}},{"type":"AnswerQuestion","contents":{"position":{"top":108.312,"left":15,"width":180,"height":31.7459},"branch":[{"selectOptions":[],"numList":[21],"ixList":[36],"blockIndex":0}]}},{"type":"AnswerQuestion","contents":{"position":{"top":140.058,"left":15,"width":180,"height":22.7512},"branch":[{"selectOptions":[],"numList":[22],"ixList":[37],"blockIndex":0}]}},{"type":"Object","contents":{"position":{"top":172.1214,"left":15,"width":180,"height":30},"branch":[{"selectOptions":[],"chooseCount":2,"subAreaTopicType":"Judge","position":{"top":0,"left":0,"width":21.5,"height":30},"colOffset":6.75,"rowOffset":5,"ixList":[38,39,40,41,42],"numList":[101,102,103,104,105],"orientation":0,"firstOption":{"top":3.5291,"left":10.0098,"width":4,"height":3},"chooses":["T","F"]},{"selectOptions":[],"chooseCount":2,"subAreaTopicType":"Judge","position":{"top":0,"left":21.5,"width":21.5,"height":30},"colOffset":6.75,"rowOffset":5,"ixList":[43,44,45,46,47],"numList":[106,107,108,109,110],"orientation":0,"firstOption":{"top":3.5291,"left":10.0098,"width":4,"height":3},"chooses":["T","F"]}]}},{"type":"EnglishComposition","contents":{"branch":[{"selectOptions":[],"numList":[1],"ixList":[49]}],"position":{"top":247.5022,"left":15,"width":180,"height":13.7565}}},{"type":"Composition","index":2,"contents":{"branch":[{"selectOptions":[],"numList":[1],"ixList":[48]}],"position":{"top":211.4335,"left":15,"width":180,"height":26.756500000000003}}}],"pageNumMarks":[{"children":[],"position":{"top":278,"left":33,"width":30,"height":10},"pageIndex":1,"blockCount":2,"firstOption":{"top":3,"left":5,"width":8,"height":4},"colOffset":11,"elementType":"PAGENUMICON","parent":null,"pTop":0}],"pageIndex":1}],"answerSheetType":2,"paperName":{"name":"0225","position":{"top":22,"left":15,"width":180,"height":20}},"paperType":"A4"}'
                // let topicCollections = '{"missScore":0,"topicTypeDescs":[{"id":"c24ce2ab-db40-4e83-8f85-003f37f426b2","pageOffset":0,"topicDescs":[{"selectOptions":[],"missScore":0,"id":"42259072-8800-4a84-839e-08b0f8cbb6f0","blockList":[],"blockIndex":0,"noList":[1],"indexList":[1],"optionCount":4,"topicType":"SingleChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"2c5cdafc-d9e6-49de-8a85-e4671d4159e7","blockList":[],"blockIndex":0,"noList":[2],"indexList":[2],"optionCount":4,"topicType":"SingleChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"3b5405d1-29a0-4b84-af31-0f5090c6d9d8","blockList":[],"blockIndex":0,"noList":[3],"indexList":[3],"optionCount":4,"topicType":"SingleChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"4c032813-442f-4d46-9c90-b381e9fb5296","blockList":[],"blockIndex":0,"noList":[4],"indexList":[4],"optionCount":4,"topicType":"SingleChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"9272b3e4-6b34-41a1-8a87-d0f1ff01ddd4","blockList":[],"blockIndex":0,"noList":[5],"indexList":[5],"optionCount":4,"topicType":"SingleChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"7acf6543-31e8-40ad-82c3-ce66b5018402","blockList":[],"blockIndex":0,"noList":[6],"indexList":[6],"optionCount":4,"topicType":"SingleChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"e7fa7d75-148e-4961-8618-887c54d97cb6","blockList":[],"blockIndex":0,"noList":[7],"indexList":[7],"optionCount":4,"topicType":"SingleChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"de33acb3-1968-45a9-b10b-d5fdd4425981","blockList":[],"blockIndex":0,"noList":[8],"indexList":[8],"optionCount":4,"topicType":"SingleChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"b8f19692-0f81-4d0e-8224-671fd150ead2","blockList":[],"blockIndex":0,"noList":[9],"indexList":[9],"optionCount":4,"topicType":"SingleChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"ce375e9f-72e2-466e-addb-68f75306c62c","blockList":[],"blockIndex":0,"noList":[10],"indexList":[10],"optionCount":4,"topicType":"SingleChoice","scoreList":[0]}],"title":"<p>单选题</p>","beginNo":1,"endNo":10,"category":"SingleChoice","optionCount":4},{"id":"84397dda-da6d-47ec-8f1d-2435a0b33abf","pageOffset":0,"topicDescs":[{"selectOptions":[],"missScore":0,"id":"d45c83cc-24af-433e-9000-bb0d0136b24a","blockList":[],"blockIndex":0,"noList":[1,2,3,4,5],"indexList":[11,12,13,14,15],"optionCount":2,"topicType":"FillBlank","scoreList":[0,0,0,0,0],"index":0,"content":"<p style=\"margin-inline-end: 10px\">&ensp;&ensp;1．&#8203;<u>&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;</u>&ensp;&ensp;2．&#8203;<u>&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;</u></p><p style=\"margin-inline-end: 10px\">&ensp;&ensp;3．&#8203;<u>&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;</u>&ensp;&ensp;4．&#8203;<u>&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;</u></p><p style=\"margin-inline-end: 10px\">&ensp;&ensp;5．&#8203;<u>&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;</u></p>","height":31.746,"sub_id":"5630e7f0-6cb9-4523-b25f-c349db025f63"}],"title":"<p>填空题</p>","beginNo":1,"endNo":5,"category":"Subject","optionCount":2},{"id":"83d48a97-87ed-42bf-aed2-a1a68e41208f","pageOffset":0,"topicDescs":[{"selectOptions":[],"missScore":0,"id":"1b33b73d-3863-4049-ba70-9cdeaf70f8fc","blockList":[],"blockIndex":0,"noList":[1],"indexList":[16],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"f29d454e-336f-4503-8856-75a0301db223","blockList":[],"blockIndex":0,"noList":[2],"indexList":[17],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"992813d3-085f-4f83-9488-963dd319569e","blockList":[],"blockIndex":0,"noList":[3],"indexList":[18],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"eb6649c9-a710-4de5-bd89-24ea9004dea4","blockList":[],"blockIndex":0,"noList":[4],"indexList":[19],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"b483a8be-2a70-43cc-b24f-172fc60d07b0","blockList":[],"blockIndex":0,"noList":[5],"indexList":[20],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"e653cdcd-ab49-4628-87c5-4e08e165c22a","blockList":[],"blockIndex":0,"noList":[6],"indexList":[21],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"a23b3727-8f7c-42b2-83fd-293f7a599239","blockList":[],"blockIndex":0,"noList":[7],"indexList":[22],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"a2b2e31e-cabf-42ab-ba35-10c6b01a83e6","blockList":[],"blockIndex":0,"noList":[8],"indexList":[23],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"d6136da2-9764-4a77-bdd9-d282ae3d8907","blockList":[],"blockIndex":0,"noList":[9],"indexList":[24],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"e16d9e63-9983-4c9f-a83a-dd601d3a5f2c","blockList":[],"blockIndex":0,"noList":[10],"indexList":[25],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"8c73d6c7-e1fd-4679-b1f0-7edc6489e28c","blockList":[],"blockIndex":0,"noList":[11],"indexList":[26],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"e6157954-e02c-4965-b873-0fadbe45ee61","blockList":[],"blockIndex":0,"noList":[12],"indexList":[27],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"5cabf560-54dd-4dc8-8054-dc002381ad88","blockList":[],"blockIndex":0,"noList":[13],"indexList":[28],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"2dc2acbc-6c7a-40ff-97a6-817a1935005a","blockList":[],"blockIndex":0,"noList":[14],"indexList":[29],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"bb34eaf0-2a7a-42ed-af56-8fc6d81cfc2a","blockList":[],"blockIndex":0,"noList":[15],"indexList":[30],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"3c37dd96-dbb9-4882-bb6b-e0290f49a666","blockList":[],"blockIndex":0,"noList":[16],"indexList":[31],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"cf3a8b4d-dbc1-4e89-9b89-a5c1c2e65907","blockList":[],"blockIndex":0,"noList":[17],"indexList":[32],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"a8f64322-fe92-456c-b920-e8cb11d8b527","blockList":[],"blockIndex":0,"noList":[18],"indexList":[33],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"b8c41661-3e5f-4863-88cf-4d0301afd0cf","blockList":[],"blockIndex":0,"noList":[19],"indexList":[34],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"0cbf4e22-eb94-463d-a58e-badff8aab9dd","blockList":[],"blockIndex":0,"noList":[20],"indexList":[35],"optionCount":15,"topicType":"MultiChoice","scoreList":[0]}],"title":"<p>多选题</p>","beginNo":1,"endNo":20,"category":"MultiChoice","optionCount":15},{"id":"d5db1264-bb14-4bd2-a610-e2989dc744f0","pageOffset":0,"topicDescs":[{"selectOptions":[],"missScore":0,"id":"bac25268-716b-41f0-bf37-bbb340138d43","blockList":[],"blockIndex":0,"noList":[21],"indexList":[36],"topicType":"AnswerQuestion","content":"<p class=\"\"><span>21．​</span>​</p><p class=\"auto-add\">​</p><p class=\"auto-add\">​</p>","scoreList":[0],"index":0,"height":31.746,"sub_id":"3b502b1a-d0d3-41dc-b30e-0646e47f285a"},{"selectOptions":[],"missScore":0,"id":"107aff15-862e-482d-a3ad-29997c9f9fe8","blockList":[],"blockIndex":0,"noList":[22],"indexList":[37],"topicType":"AnswerQuestion","content":"<p class=\"\"><span>22．​</span>​</p><p class=\"auto-add\">​</p>","scoreList":[0],"index":0,"height":22.7513,"sub_id":"a4696c0e-a9f3-476a-a170-5ed48c4a5948"}],"title":"<p>解答题</p>","beginNo":21,"endNo":22,"category":"Subject"},{"id":"868e161e-7332-4ce5-9145-5ac727af9d5c","pageOffset":0,"topicDescs":[{"selectOptions":[],"missScore":0,"id":"70d74d93-ad37-4de3-9fd6-2f58c4656cff","blockList":[],"blockIndex":0,"noList":[101],"indexList":[38],"optionCount":2,"topicType":"Judge","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"c7cd019a-12ef-47aa-b5df-f9de5fc78a42","blockList":[],"blockIndex":0,"noList":[102],"indexList":[39],"optionCount":2,"topicType":"Judge","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"702bba50-b94d-4e52-85e5-7f0e2737ac49","blockList":[],"blockIndex":0,"noList":[103],"indexList":[40],"optionCount":2,"topicType":"Judge","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"903b31fc-2475-4f70-9392-963c45322d0f","blockList":[],"blockIndex":0,"noList":[104],"indexList":[41],"optionCount":2,"topicType":"Judge","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"19c818f1-1e49-4f29-8270-4401100d8b40","blockList":[],"blockIndex":0,"noList":[105],"indexList":[42],"optionCount":2,"topicType":"Judge","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"3036807a-e020-4fcb-992f-788bf74ef660","blockList":[],"blockIndex":0,"noList":[106],"indexList":[43],"optionCount":2,"topicType":"Judge","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"7c4d3cdf-879c-47de-a778-e8398b2d87fc","blockList":[],"blockIndex":0,"noList":[107],"indexList":[44],"optionCount":2,"topicType":"Judge","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"b3c5704c-2ebe-461a-9e1f-f3ed48b7060f","blockList":[],"blockIndex":0,"noList":[108],"indexList":[45],"optionCount":2,"topicType":"Judge","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"48fa6b8b-318d-4c92-aa3e-ac68d01d31b7","blockList":[],"blockIndex":0,"noList":[109],"indexList":[46],"optionCount":2,"topicType":"Judge","scoreList":[0]},{"selectOptions":[],"missScore":0,"id":"43de008b-ab24-4366-b888-bf080dd8562e","blockList":[],"blockIndex":0,"noList":[110],"indexList":[47],"optionCount":2,"topicType":"Judge","scoreList":[0]}],"title":"<p>判断题</p>","beginNo":101,"endNo":110,"category":"SingleChoice","optionCount":2},{"id":"d6095ec3-cd9a-4c33-95d5-ac8ce192f262","pageOffset":0,"topicDescs":[{"selectOptions":[],"missScore":0,"id":"fa8318f3-33bb-4fe8-bd1b-c76992e2c7df","blockList":[],"blockIndex":0,"noList":[1],"indexList":[48],"optionCount":10,"beginNo":1,"topicType":"Composition","content":"<p>1．</p>","scoreList":[0],"index":0,"start":1,"height":13.7566,"sub_id":"2b2fcac7-cabe-42d6-ae3e-4f1af6aaa13b"}],"title":"<p>作文题</p>","beginNo":1,"endNo":"1","category":"Subject","optionCount":10},{"id":"a657a91d-6382-45af-989d-3edf8a09b496","pageOffset":0,"topicDescs":[{"selectOptions":[],"missScore":0,"id":"e0d77091-2ad0-43d1-9fdb-48a4b891838d","blockList":[],"blockIndex":0,"noList":[1],"indexList":[49],"optionCount":1,"beginNo":1,"topicType":"EnglishComposition","scoreList":[0],"index":0,"content":"<p style=\"margin-inline-end: 10px\">1．<u>&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;</u></p>","height":13.7566,"sub_id":"52d877a2-81e4-498d-bb57-1118a4a04d93"}],"title":"<p>英语作文</p>","beginNo":1,"endNo":"1","category":"Subject","optionCount":1}]}'

                let jsonInfo = JSON.parse(info);
                let pageSheets = jsonInfo.pageSheets
                // 获得对应的题目
                this.getTopicList(topicCollections)

                // 获取到全部的题
                let total = []
                for( let i =0 ;i < pageSheets.length ;i ++){
                    let sections = pageSheets[i].sections
                    // let optionList = sections.filter(item => item.type != 'Object')
                    // 包含全部题型
                    let optionList = sections
                    total.push(...optionList)
                }
                // debugger
                // 设定分组id(从0开始)
                let groupByIds = 0

                let result = []

                // 循环客观题
                total.forEach((element,index) => {

                    debugger

                    // 新增个输入框区域
                    let input_ = {
                        type: 'input',
                        groupId: groupByIds,
                        // 大题块类型
                        topic_type: element.type,
                        batchScore: null,
                        batchAnswer: null
                    }
                    result.push(input_)

                    // 判断有几个input 取对应的答题卡题目
                    let input_index = result.filter(item=> item.type =='input').length
                    input_.name = this.titleList[input_index -1 ]
                    

                    // 大题块的题型（单选题，多选题，填空题...）
                    let topicType = element.type
                    // 大题块的总题目序号
                    let topicNumList= []

                    let type = element.type

                    // 用于判断题区位置
                    let location = {
                        top: 0,
                        left: 0
                    }

                    // 一个题区一个回车
                    let branch = element.contents.branch

                    // 组内id(从0开始)
                    let branchId = 0
                    for(let i = 0 ; i< branch.length ; i ++){

                        // 如果是主观题那不需要判断位置，只需要简单列出ixList
                        if(type == 'Object'){
                            let position = branch[i].position
                            // 如果两个都是0 就说明是第一行第一个 ，只需要更新位置
                            if(location.top == 0 && location.left == 0){
                                location.left = position.left
                                location.top = position.top
                            }else{
                                // 更新位置信息前判断，该branch 的位置是同一行 还是下一行
                                let beforeTop = location.top
                                let afterTop = position.top
                                
                                // Y轴不变则说明在同一行内 反之则不在同一行并插入回车
                                if(beforeTop != afterTop){
                                    let enter = {type: 'enter'}
                                    result.push(enter)
                                }
                                location.left = position.left
                                location.top = position.top
                            }
                        }

                    
                        // 获取到该题区的ixList(作为更新序号),numList(作为题号),
                        let ixList = branch[i].ixList
                        let numList = branch[i].numList

                        // 大题块序号拼接
                        topicNumList.push(...numList)

                        // 判断是主观题还是客观题
                        if(type == 'Object'){

                            let choosesList = branch[i].chooses
                            let chooseCount = branch[i].chooseCount
                            // 给上边的输入框提供客观题的选项数目
                            input_.chooseCount = chooseCount

                            // 客观题类型
                            let subAreaTopicType = branch[i].subAreaTopicType

                            topicType = subAreaTopicType

                            // 判断主观题类型 如果主观题是多选题则正确答案为数组类型
                            let rightAnswer = null
                            if(subAreaTopicType == 'MultiChoice') rightAnswer = []

                            let ixJson = []
                            
                            ixList.forEach((ele,index) => {
                                // 判断是否需要断行
                                let json = {
                                    ixNum: ele,
                                    numNum: numList[index],
                                    topic_type: subAreaTopicType,
                                    topic_type2: 'Object',
                                    option_count: chooseCount,
                                    answer: rightAnswer,
                                    type: 'kg',
                                    groupId: groupByIds,
                                    // 行id
                                    rowId: "id" + groupByIds + "-" + branchId,
                                    // 行索引
                                    rowNum: branchId
                                
                                }
                                ixJson.push(json)
                                // 一题一题的
                                this.totalTopicList.push(json)
                                branchId = branchId + 1
                            });
                            
                            // 题块
                            result.push({type: 'kg',list: ixJson})

                            // 获取当前result 的索引位置
                            let name = "id" + groupByIds
                            // 由于题区分割 多个索引对应一个题区
                            if(name in this.zgInfoIndex){
                                this.zgInfoIndex[name].push(result.length -1)
                            }else{
                                // 为空初始化
                                this.zgInfoIndex[name] = [result.length -1]
                            }

                        }else{
                            // 主观题(多题集合)
                            let ixJson = []
                            ixList.forEach((ele,index) => {
                                // 以ixNum 为准(唯一标识) 如果有一样的 就默认是同题的跨页 不进行新增
                                let isExist = this.totalTopicList.find(item => item.ixNum == ele) == null ? true : false
                                if (isExist){
                                    let json = {
                                        ixNum: ele,
                                        numNum: numList[index],
                                        answer: null,
                                        topic_type: type,
                                        topic_type2: "Subjective",
                                        type: 'zg',
                                        groupId: groupByIds,
                                        // 行id
                                        rowId: "id" + groupByIds + "-" + branchId,
                                        // 行索引
                                        rowNum: branchId,
                                        // 是否已经存在(跨页)
                                        isExist: isExist
                                    
                                    }
                                    // 一题一题的
                                    ixJson.push(json)
                                    this.totalTopicList.push(json)
                                }else{

                                    // 删除掉跨页的ixNum(以ixList的索引为准 查找指定索引的numList题号是多少并删除)
                                    let a = ixList.indexOf(ele)
                                    if (a > -1) {
                                        let num = numList[a]
                                        topicNumList = topicNumList.filter(item => item !== num)
                                    }

                                }
                                branchId = branchId + 1
                            });

                            if(ixJson.length > 0){
                                // 题块
                                result.push({type: 'zg',list: ixJson})
                                // 获取当前result 的索引位置
                                let name = "id" + groupByIds
                                this.zgInfoIndex[name] = result.length -1
                            }
  
                        }


                    }
                    debugger
                    if (topicNumList.length > 0){
                        // 直接生成
                        let topic = {
                            groupId: groupByIds,
                            count: branchId ,
                            topic_type: topicType,
                            numList: topicNumList,
                            score: 0,
                        }
                        // debugger
                        // 侧边数据
                        let list = this.topicTableByCount(topic)
                        topic.list = list
                        // 去掉批量设置
                        topic.totalNum = list.length -1
                        this.scoreList.push(topic)

                        // 每个 element 自动为一个题区进行分区
                        let enter = {type: 'enter'}
                        result.push(enter)
                    }else{
                        // 为空情况下 删除之前注入的 输入框
                        debugger
                        if (result.length > 0) result.splice(result.length - 1, 1)
                    }

                    groupByIds = groupByIds + 1 


                });
                debugger
                this.zgInfo = result
                this.countTopicNum()

            },
            // 单选切换选中/取消
            singleChoiceCheck(item,check) {
                item.answer = check
                // 同步更新scoreList中的答案
                // 行的groupId 包含完整的groupId 和 rowId
                let groupId = item.groupId
                let rowId = item.rowId
                let rows = this.scoreList[groupId].list.find(item=> item.rowId == rowId)
                // 更新答案
                rows.answer = check
            },
            // 多选切换选中/取消
            multiChoiceCheck(item,check) {
                // 多选题保证答案格式是数组
                if (!Array.isArray(item.answer)) {
                    item.answer = []
                }
                let index = item.answer.indexOf(check)
                if (index > -1) {
                    // 取消选中
                    item.answer.splice(index, 1);
                } else {
                    // 选中
                    item.answer.push(check);
                }
            },

            // 生成侧边题目数据总览
            topicTableByCount(item){
                // debugger
                // 根据行数 生成对应的table格式的数据
                let count = item.count
                let numList = item.numList
                let groupId = item.groupId
                let topic_type = item.topic_type
                // 批量
                let data = [
                    { 
                        score: 0,
                        groupId: groupId,
                    }
                ]
                // let data = []
                for(let i=0; i < count; i++){
                    let topic = {
                        // 题序
                        num: numList[i],
                        // 行唯一id
                        rowId: "id" + groupId + "-" + i,
                        // 分数默认0分
                        score: 0,
                        // 题型
                        topic_type: topic_type
                    }
                    data.push(topic)
                }
                return data
            },
            test(item){
            },
            // 批量修改单选题/多选题类型
            changeTopicType(type,item){
                // debugger
                // 获取到当前分组
                let groupId = item.groupId
                // 获取对应zgInfo 的位置索引
                let infoIndexList = this.zgInfoIndex['id'+ groupId]
                let list = []
                // 带指针 能同步一起修改
                infoIndexList.forEach(element => {
                    list = [...list, ...this.zgInfo[element].list]
                });
                if(type == 1){
                    // 转为单选题
                    item.topic_type = 'SingleChoice'
                }else{
                    // 转为多选题
                    item.topic_type = 'MultiChoice'
                }
                // 修改指定题目的类型 清空答案
                list.forEach((ele,index) => {
                    ele.topic_type = item.topic_type
                    ele.answer = null
                    if(type != 1) ele.answer = []
                });

                // 侧边栏类型修改
                let scoreList = this.scoreList[groupId].list
                scoreList.forEach((ele,index) =>{
                    if(index == 0) return
                    ele.topic_type = item.topic_type
                })
            },
            // 单条单选题/多选题类型
            changeTopicTypeOne(type,row){
                // debugger
                let rowId = row.rowId
                let group = this.spiltRowId(rowId)
                // 获得对应排序（侧边排除掉批量修改的项）
                let num = group.rowNum
                // 获取到当前分组
                let groupId = group.groupId

                
                // 获取对应zgInfo 的位置索引
                let infoIndexList = this.zgInfoIndex['id'+ groupId]
                let list = []
                // 带指针 能同步一起修改
                infoIndexList.forEach(element => {
                    list = [...list, ...this.zgInfo[element].list]
                });

                if(type == 1){
                    // 转为单选题
                    row.topic_type = 'SingleChoice'
                }else{
                    // 转为多选题
                    row.topic_type = 'MultiChoice'
                }
                // 修改指定题目的类型 清空答案
                list.forEach((ele,index) => {
                    // debugger
                    if(index == num ){
                        ele.topic_type = row.topic_type
                        ele.answer = null
                        if(type != 1) ele.answer = []
                    }

                });
            },
            // 批量设置分数
            changeScore(type,value){
                // 判断
            },
            // 更新总分
            updateScoreList(groupId,list){
                this.scoreList[groupId].list = list
            },
            // 计算答题卡题目数，客观题总数，主观题总数
            countTopicNum(){

                // this.topicNum = this.scoreList.length
                // this.kgNum = this.scoreList.filter(item=> item.topic_type == "SingleChoice"  || item.topic_type == "MultiChoice" || item.topic_type == "Judge").length
                // this.zgNum = this.scoreList.filter(item=> item.topic_type != "SingleChoice"  && item.topic_type != "MultiChoice" && item.topic_type != "Judge").length

                let kgNum = this.scoreList.reduce((sum, group) => {
                    // 过滤出合法题型
                    let validList = group.list.filter(item => 
                        item.topic_type == "SingleChoice" || 
                        item.topic_type == "MultiChoice" || 
                        item.topic_type == "Judge"
                    );
   
                    // 每个 list再累加 (filter已经剔除掉批量设置分数的地方)
                    return sum + (validList.length );
                }, 0);
               

                let zgNum = this.scoreList.reduce((sum, group) => {
                    // 过滤出合法题型
                    let validList = group.list.filter(item => 
                        'topic_type' in item &&
                        item.topic_type != "SingleChoice" &&
                        item.topic_type != "MultiChoice" &&
                        item.topic_type != "Judge"
                    );

                    // 每个 list再累加 (filter已经剔除掉批量设置分数的地方)
                    return sum + (validList.length );
                }, 0);
                this.kgNum = kgNum
                this.zgNum = zgNum
                this.topicNum = kgNum + zgNum
            },
            // 根据分组id批量设置分数
            batchScoreByGroup(row){
                // debugger
                // 批量将选中的题区分数修改
                let groupId = row.groupId
                let score = row.batchScore
                // 通过groupId访问特定ref
                let secondTableRef = this.$refs['newExamTopicTable-' + groupId] 
                if (secondTableRef && secondTableRef[0]) {
                    let item = {
                        groupId: groupId,
                        score: score
                    }
                     // 调用子组件的方法
                    secondTableRef[0].changeScore(item) 
                }
            },
            batchScoreByGroupCheck(row){
                let groupId = row.groupId
                // 选中则展开侧边栏
                this.activeNames = groupId
            },
            batchAnswerByGroupCheck(row){
                let groupId = row.groupId
                // 选中则展开侧边栏
                this.activeNames = groupId
            },
            // 根据分组id批量设置答案(单选判断题 和 多选题区分)
            batchAnswerByGroup(row){
                // debugger
                // 答案规则过滤
                let answer = row.batchAnswer
                answer = this.filterAnswer(answer,row.chooseCount)
                row.batchAnswer = answer 
                if (answer == null) return
                // 获取到当前分组
                let groupId = row.groupId
                // 选中则展开侧边栏
                // this.activeNames = groupId
                // 获取对应zgInfo 的位置索引
                let infoIndexList = this.zgInfoIndex['id'+ groupId]
                let list = []
                // 带指针 能同步一起修改
                infoIndexList.forEach(element => {
                    list = [...list, ...this.zgInfo[element].list]
                });
                // 判断是单选题还是多选题(多选题以,区分)
                let type = 'SingleChoice'
                if(list.length > 0) type = list[0].topic_type
                
                
                // 排除掉批量修改的
                let topicList = this.scoreList[groupId].list.filter(item=> 'rowId' in item)
                if(type == 'SingleChoice' || type == 'Judge'){
                    topicList.forEach((ele,index) => {
                        let anw = answer.charAt(index)
                        ele.answer = anw
                        // 对应的页面信息更新
                        list[index].answer = anw
                    });
                }else{
                    // 多选题
                    let anwList = answer.split(',')
                    topicList.forEach((ele,index) => {
                        let anw = anwList[index].split('')
                        if(anw.length == 0)  anw = []
                        ele.answer = anw
                        // 逗号切割后的字符 单个字符拼接
                        // 对应的页面信息更新
                        list[index].answer = anw
                    });
                }
                
            },
            filterAnswer(answer,optionCount){
                // debugger
                let that = this
                let isAnswer = answer == undefined || answer == '' || answer == null
                if (isAnswer) {
                    return answer // 空值直接返回
                }
                // 过滤中文字符
                answer = answer.replace(/[\u4e00-\u9fa5]/g, '')
                // let isChinese = /[\u4e00-\u9fa5]/.test(answer)
                // if(isChinese && !isAnswer) {
                //     that.$message.error("答案不允许存在中文字符，请检查答案格式！");
                //     answer = null
                //     return answer;
                // }

                // 过滤字母 只允许A-O,TF字母(不限制大小写,i: 忽略大小写)
                // answer = answer.replace(/[^A-OTF,]/gi, '')

                // 根据选择题的选项数 允许生成对应范围的字母
                let allowedLetters = ''
                for (let i = 0; i < optionCount; i++) {
                    allowedLetters += String.fromCharCode(65 + i) // 65 = A
                }

                // 选项数量=2 时，额外允许 T、F
                if (optionCount === 2) {
                    allowedLetters += 'TF'
                }
                // 只保留允许的字母 + 逗号
                let reg = new RegExp(`[^${allowedLetters},]`, 'gi')
                answer = answer.replace(reg, '')

                // let isStr = /^[A-OTF,]+$/i.test(answer)
                // if(!isStr && !isAnswer) {
                //     that.$message.error("答案只允A~O,TF内的字母以及','进行分割，请检查答案格式！");
                //     answer = null
                //     return answer;
                // }


                // 统一转为大写字母
                // if(!isAnswer) answer = answer.toUpperCase()
                answer = answer.toUpperCase()

                // 违法字符处理掉后为空的情况下，弹出提示
                if (answer.trim() === '') {
                    that.$message.error('答案只允A~O、T、F 以及英文逗号分隔！')
                    return ''
                }
                return answer
            },
            // 保存校验
            submitCheck(){
                // debugger
                // 空值校验
                this.isAnswerEmpty = false
                this.isScoreEmpty = false

                // 同步分数对应
                // 多选题是否存在多个答案
                // 题目集合
                let totalTopicList = JSON.parse(JSON.stringify(this.totalTopicList))
                // 分数集合
                let scoreList = this.scoreList
                totalTopicList.forEach((ele,index) => {
                    let groupId = ele.groupId
                    let rowNum = ele.rowNum
                    // 跳过批量设置
                    let score = scoreList[groupId].list[rowNum + 1].score
                    ele.score = score

                    // 添加分组id 
                    let questionId = ele.rowId.split('-')[0]
                    ele.question_id = questionId
                    ele.exam_id = this.examId
                    ele.topic_index = ele.ixNum
                    ele.topic_no = ele.numNum


                    // 多选题的答案转换成由,拼接的字符串
                    if(ele.topic_type == 'MultiChoice' || ele.topicType == 'MultiChoice'){
                        let ans  = ele.answer.join(',')
                        ele.answer = ans
                    }
                    
                  
                });
                // 不得存在0分,除主观题外 客观题不得未设置答案
                // debugger
                let emptyList = this.checkListByGroupId(totalTopicList)
                let scoreData = emptyList.scoreData
                let answerData = emptyList.answerData
                
                // 遍历所有分组
                for (let groupId in scoreData) {
                    let { total, emptyCount } = scoreData[groupId]
                    if (emptyCount > 0) {
                        this.isScoreEmpty = true
                        break 
                    }
                }
                for (let groupId in answerData) {
                    let { total, emptyCount } = answerData[groupId]
                    if (emptyCount > 0) {
                        this.isAnswerEmpty = true
                        break 
                    }
                }
                if(this.isScoreEmpty || this.isAnswerEmpty) {
                    this.isAnswerEmptyList = answerData
                    this.isScoreEmptyList = scoreData
                    this.$message.warning("答题卡设置存在空值,请重新检查！")
                    return 
                }                
                // 多选题的答案不得少于2个 最终保存答案以,拼接

                // 判断总分是否是整数 如果非整数提示是否确定保存
                let totalScore = this.totalScore
                if(totalScore % 10 != 0){
                    let title = '此答题卡总分' + totalScore +'非整数，请确定是否以此分值保存答案！'
                    this.$confirm(title, {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                            this.submitForm(totalTopicList)
                        }).catch(() => {
                        });
                }else{
                    this.submitForm(totalTopicList)
                }

            },
            // 以分组(侧边栏) 校验对应的答案和分数的空值
            checkListByGroupId(list) {
                let answerData = {}

                let scoreData = {}

                // 遍历所有题目
                list.forEach(item => {
                    let groupId = String(item.groupId) || 'default' // 分组ID
                    // 初始化分组
                    if (!answerData[groupId]) {
                        answerData[groupId] = {
                            total: 0,
                            emptyCount: 0
                        }
                    }
                    if (!scoreData[groupId]) {
                        scoreData[groupId] = {
                            total: 0,
                            emptyCount: 0
                        }
                    }
                    

                    // 总数+1
                    answerData[groupId].total++
                    scoreData[groupId].total++

                    // debugger
                    // 先判断分数是否为空
                    let isScoreEmpty = !item.score || item.score === '' 

                    if (isScoreEmpty) {
                        scoreData[groupId].emptyCount++
                        // return
                    }

                    // 如果分数不为空 但是答案为空的情况下 判断是否是主观题 是主观题就略过
                    // debugger
                    let isAnswerEmpty = !item.answer || item.answer === '' || item.answer.length == 0
                    if(isAnswerEmpty){
                        if(item.type != "zg")  answerData[groupId].emptyCount++
                    }
                })
                return {
                    'scoreData':scoreData,
                    'answerData': answerData
                }
            },
            // 保存
            submitForm(totalTopicList){
                // debugger
                let search = { examId: this.examId ,list: totalTopicList};
                let param = { controllerName: 'akExamTopic', methodName: '/saveTopicByLayout', param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    // debugger
                    if(code == 0){
                        this.$message.success("保存成功！")
                        this.cancel()
                    }
                }).catch((error) => {
                    console.log("error")
                });
            },
            // 题型题量比对
            changeTopic(){
                // debugger
                // 答题卡的题型
                let totalTopicList = this.totalTopicList
                // 保存后题型
                let totalTopicListById = this.totalTopicListById
                // 极端情况下 判断这俩的数量是否一致
                if(totalTopicList.length != totalTopicListById.length) {
                    this.$message.error("答题卡与已保存的题数不一致！ 请检查答题卡绑定是否生效！")
                    return
                }

                let scoreList = this.scoreList

                // 已按照ixNum 顺序排序，获取对应答案与id
                totalTopicList.forEach((ele,index) => {
                    let item = totalTopicListById[index]
                    ele.id = item.id
                    ele.score = item.score
                   
                    // 防止题目类型进行过修改
                    ele.topic_type = item.topic_type
                    ele.topicType = item.topicType

                    ele.topic_type2 = item.topic_type2
                    ele.topicType2 = item.topicType2

                    // 特殊规则同步
                    ele.score_rules = item.score_rules

                    // 右侧同步更新分数
                    let groupId = ele.groupId
                    let rowNum = ele.rowNum
                    // 侧边栏类型
                    // debugger
                    scoreList[groupId].list[rowNum + 1].topic_type = item.topic_type
                    scoreList[groupId].list[rowNum + 1].score = item.score

                    // 题目类型为多选题时 答案格式修改为[]
                    if(ele.topic_type == 'MultiChoice' || ele.topicType == 'MultiChoice'){
                        // debugger
                        let ans  = []
                        // 有可能是空值
                        let isAnswerEmpty = !item.answer || item.answer === ''
                        if(!isAnswerEmpty){
                            ans  = item.answer.split(',')
                        }
                        ele.answer = ans

                    }else{
                        ele.answer = item.answer
                    }
                });
            },
            handleChange(val) {
                this.activeNames = val.slice(-1);
            },
            // 截取rowId 对应的groupId 和rowNum
            spiltRowId(rowId){
                // 捕获两组数字
                let reg = /id(\d+)-(\d+)/;
                let res = rowId.match(reg);

                if (res) {
                    let groupId = parseInt(res[1]); 
                    let rowNum  = parseInt(res[2]); 
                    return {
                        'groupId': groupId,
                        'rowNum': rowNum
                    }
                }
            },

            // 特殊规则获取对应的值
            getSpecialData(row,callback){
                // debugger
                let rowId = row.rowId
                // 获取到当前分组,获得对应排序
                let group = this.spiltRowId(rowId)
                let groupId = group.groupId
                let num = group.rowNum

                // 获取对应zgInfo 的位置索引
                let infoIndexList = this.zgInfoIndex['id'+ groupId]
                let list = []
                // 带指针 能同步一起修改
                infoIndexList.forEach(element => {
                    list = [...list, ...this.zgInfo[element].list]
                });

                let data = list[num]
                callback(data)
            },
            // 同步更新特殊规则
            setScoreRules(scoreRules,item){
                let groupId = item.groupId
                let rowId = item.rowId
                let totalTopicList = this.totalTopicList
                let topic = totalTopicList.filter(item => item.rowId == rowId)
                if(topic.length > 0)topic[0].score_rules =  JSON.stringify(scoreRules)

            },
            zgTopicGroup(info){

                let list = info.list
                let length = list.length
                if (length == 0 ) return
                let title = ''
                // formatTitle( item.topic_type) 
                let type = this.formatTitle(list[0].topic_type)
                if(length == 1){
                    title = type + "：  " + list[0].numNum +" 题"
                }else{
                    title = type + "：  " + list[0].numNum + "~" + list[length - 1].numNum + " 题"
                }
                
                return title
            }
        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
 .container {
    display: flex;
    // flex-direction: column;
    flex-wrap: wrap;
    gap: 16px;
    padding: 20px;
    justify-content: flex-start;
 }

/* 水平布局：左右排列 */
.card-horizontal {
//   display: flex;
  display: inline-flex;  /* 改为 inline-flex */
  // 外边距
//   gap: 5px;
//   align-items: center;
}

/* 垂直布局：上下排列 */
.card-vertical {
  display: flex;
  flex-direction: column;
  // 行间隔
  gap: 5px;
  border: 1px;
//   margin-left: 20px;
}
.break {
    width: 100%;        /* 占满整行 */
    height: 1px;       /* 给点高度才能看到 */
    text-align: center;
}
/* 换行元素 - 占满整行，强制换行 */
/* 关键：break-line 占满整行 */
.break-line {
  width: 100%;        /* 占满整行 */
  height: 1px;       /* 给点高度才能看到 */
  text-align: center;
//   margin: 10px 0;
  background-color: #e5e5e5; /* 这就是横线 */

  box-shadow: 0 2px 10px rgba(43, 111, 242, 0.25), 0 0 10px rgba(43, 111, 242, 0.1);
}


.letter-container {
  display: flex;
  flex-wrap: wrap;
  // 选项间隔
  gap: 8px;
  padding-left: 5px;
//   padding: 5px;
}

.letter-item {
  // 选项高宽
  width: 30px;
  height: 30px;
  line-height: 26px;
  text-align: center;
  cursor: pointer;
  border-radius: 3px;

  font-size: 18px;
//   font-weight: bold;
}
.letter-item.active {
  background-color: #0066ff;
  color: #fff;
}

.multi_choice{
    color: rgb(248, 120, 120);
}

//侧边栏样式

// 侧边栏悬浮
.fixed-sidebar {
  position: sticky; /* 核心：吸顶 */
  top: 20px;        /* 距离顶部多少距离开始固定 */
  align-self: flex-start;
  max-height: calc(100vh - 40px); /* 防止高度超出屏幕 */
  overflow-y: auto; /* 内容多了自己内部滚动 */
//   background-color: red;
}

:deep(.el-collapse-item__header) {
  flex-direction: row-reverse !important;
  justify-content: flex-start !important;
  padding-left: 8px !important;
}

.title-wrapper {
  display: flex;
//   justify-content: flex-end; /* 所有内容靠右排列 */
  align-items: center;       /* 垂直居中 */
  gap: 12px;                 /* 间距统一 */
  width: 100%;
}

.collapse-title, .tip-num {
  white-space: nowrap; /* 防止文字换行导致错位 */
}

.tip-num {
  color: #f56c6c;
  font-weight: bold;
}

/** 折叠菜单选中时 标题换色 */
.el-collapse-item.is-active .collapse-title {
  color: #2B6FF2 !important; // 你的主题蓝色
//   background-color: red;
//   width: 100%
}


.fixed-blue-card.el-card {
  /* 1. 固定显示蓝色阴影（无论是否 hover 都不会变） */
  box-shadow: 0 4px 20px rgba(43, 111, 242, 0.25) !important;
  /* 2. 设置圆角 */
  border-radius: 12px;
  /* 3. 避免 hover 时阴影变化，保持固定 */
  transition: none !important; 
  margin: 5px;
}

/* 如果 CSS 权重不够，可以同时限制 hover 状态保持不变 */
.fixed-blue-card.el-card:hover {
  box-shadow: 0 4px 20px rgba(43, 111, 242, 0.25) !important;
}



/* 使用 ::v-deep 穿透 scoped，确保能修改 el-input 内部样式 */
.fixed-blue-input ::v-deep .el-input__inner {
  /*  固定蓝色边框 */
  border-color: #2B6FF2 !important;
  /* 外围蓝色发光阴影（不占空间，像光晕） */
//   box-shadow: 0 0 0 2px rgba(43, 111, 242, 0.15), 0 0 8px rgba(43, 111, 242, 0.1) !important;
    font-size: 18px
}

/* 强制覆盖 hover 和 focus 状态，防止变回灰色 */
.fixed-blue-input ::v-deep .el-input__inner:hover,
.fixed-blue-input ::v-deep .el-input__inner:focus {
  border-color: #2B6FF2 !important;
  box-shadow: 0 0 0 2px rgba(43, 111, 242, 0.25), 0 0 12px rgba(43, 111, 242, 0.15) !important;
}


.wrapper {
  display: flex;          /* 开启 flex 布局 */
  flex-direction: row;    /* 默认水平排列，可省略 */
  margin-top: 5px

}


.card-stats {
  display: flex;
  justify-content: center;   /* 水平居中整体 */
  gap: 20px;                 /* 卡片之间的间隔，可调 */
  flex-wrap: wrap;           /* 如果屏幕太窄则换行，但通常四个在一行 */
  padding: 16px 0;           /* 上下留白，可选 */
  border-radius: 20px;       /* 圆角 */
  
}


.card-stats .el-card {
  flex: 0 1 auto;           /* 不拉伸，宽度由内容决定 */
  width: 200px;             /* 宽度 */
  height: 80px;
  text-align: center;       /* 内部文字居中（可选） */
  background-color: #fffdfd
}

.card-stats .el-card h1{
  font-size: 25px;
}
.card-stats .el-card h2{
  font-size: 18px;
}


</style>


